import ReactQRCode from 'react-qr-code'
import { styled } from 'styled-components'

const QRCodeContainer = styled.div<{ $size: number }>`
  display: inline-flex;
  padding: ${({ theme }) => theme.spacings.md}px;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  border-radius: ${({ theme }) => theme.radiuses.md}px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale[100]};

  svg {
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    display: block;
  }
`

export interface QRCodeProps {
  value: string
  size?: number
  level?: 'L' | 'M' | 'Q' | 'H'
  bgColor?: string
  fgColor?: string
  className?: string
}

const QRCode: FC<QRCodeProps> = ({
  value,
  size = 256,
  level = 'M',
  bgColor = '#FFFFFF',
  fgColor = '#000000',
  className
}) => {
  return (
    <QRCodeContainer $size={size} className={className}>
      <ReactQRCode value={value} size={size} level={level} bgColor={bgColor} fgColor={fgColor} />
    </QRCodeContainer>
  )
}

export default QRCode
